<div class="container mt-8 pb-5">
  <div class="row justify-content-center">
    <div class="col-lg-5 col-md-7">
      <div class="card">
        <div class="card-body px-lg-5 py-lg-5">
          <div class="text-center text-muted mb-4">
            <img src="assets/img/brand/logo.png" style="max-width: 300px;" class="mb-4 w-100" />
            <h1>{{step}}</h1>
          </div>

          <!-- login -->
          <form *ngIf="step=='Se connecter' && stepLoginPhone == ''" role="form" [formGroup]="loginForm"
            (ngSubmit)="onSubmit()">
            <div class="form-group mb-3">
              <div class="input-group input-group-alternative">
                <div class="input-group-prepend">
                  <span [ngClass]="{'icon-border-error':formControl.identifier.errors && submitted}"
                    class="input-group-text"><i class="ni ni-email-83"></i></span>
                </div>
                <input [ngClass]="{'input-border-error':formControl.identifier.errors && submitted}"
                  class="form-control" placeholder="Adresse email" type="email" formControlName="identifier">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group input-group-alternative">
                <div class="input-group-prepend">
                  <span [ngClass]="{'icon-border-error':formControl.password.errors && submitted}"
                    class="input-group-text"><i class="ni ni-lock-circle-open"></i></span>
                </div>
                <input [ngClass]="{'input-border-error':formControl.password.errors && submitted}" class="form-control"
                  placeholder="Mot de passe" type="password" formControlName="password">
              </div>
            </div>
            <div class="text-center">
              <button type="submit" class="btn btn-studiomap my-4 w-100"><i
                  class="fa fa-check mr-2"></i>CONNEXION</button>
            </div>

            <h4 class="lined-text" style="color: #6a6f73;"><span>OU</span></h4>
            <button class="btn btn-outline-studiomap w-100 mt-3" type="button" (click)="loginWithPhone()">
              <i class="fa fa-phone fa-lg float-left"></i> <span>Se connecter avec numéro téléphone </span>
            </button>
            <button class="btn btn-outline-studiomap w-100 my-3" type="button" (click)="loginWithGoogle()">
              <img class="float-left" width="23" src="assets/img/google.webp" alt="mail"> <span>Se connecter avec google
              </span>
            </button>
            <button class="btn btn-outline-studiomap w-100" type="button" (click)="loginWithFB()">
              <img class="float-left" width="23" src="assets/img/facebook.webp" alt="facebook"> <span>Se connecter avec
                facebook </span>
            </button>
          </form>

          <div *ngIf="stepLoginPhone == 'send-code'" class="p-3">
            <p class="mb-4 text-center">Connectez-vous avec votre <span class="text-danger">numéro de téléphone</span>
            </p>

            <div class="form-group">
              <input type="text" id="phone" class="form-control" [(ngModel)]="phoneNumber"
                placeholder="Numéro de téléphone">
            </div>
            <div class="text-center">
              <button type="submit" class="btn btn-studiomap mb-3 w-100" (click)="loginWithPhone()">CONTINUER</button>
              <button class="btn btn-outline-studiomap w-100" type="button" (click)="back()">
                <i class="fa fa-chevron-circle-left"></i> <span>Précédent </span>
              </button>
            </div>
          </div>
          <div *ngIf="stepLoginPhone == 'validation-code'" class="p-3">
            <p class="mb-4 text-center">Connectez-vous avec votre <span class="text-danger">numéro de téléphone</span>
            </p>
            <div class="form-group">
              <input type="text" placeholder="Code de validation" class="form-control" [(ngModel)]="verificationCode">
            </div>
            <div class="text-center">
              <button type="submit" class="btn btn-studiomap mb-3 w-100" (click)="loginWithPhone()"><i
                  class="fa fa-check mr-2"></i>VALIDER</button>
              <button class="btn btn-outline-studiomap w-100" type="button" (click)="back()">
                <i class="fa fa-chevron-circle-left"></i> <span>Précédent </span>
              </button>
            </div>
          </div>

          <!-- forget password -->
          <form *ngIf="step=='Mot de passe oublié'" role="form" [formGroup]="forgetPasswordForm"
            (ngSubmit)="onSubmitForgetPassword()">
            <div class="text-center text-muted mb-4">
              Entrez votre adresse e-mail ci-dessous pour définir un nouveau mot de passe.
            </div>
            <div class="form-group mb-3">
              <div class="input-group input-group-alternative">
                <div class="input-group-prepend">
                  <span [ngClass]="{'icon-border-error':forgetFormControl.email.errors && submitted}"
                    class="input-group-text"><i class="ni ni-email-83"></i></span>
                </div>
                <input [ngClass]="{'input-border-error':forgetFormControl.email.errors && submitted}"
                  class="form-control" placeholder="Adresse email" type="email" formControlName="email">
              </div>
            </div>

            <div class="text-center">
              <button type="submit" class="btn btn-studiomap my-4 w-100"><i class="fa fa-check mr-2"></i>Envoyer un
                lien</button>
            </div>
          </form>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-6" *ngIf="step=='Se connecter'"><a href="javascript:void(0)"
            (click)="step='Mot de passe oublié';submitted=false;" class="text-dark"><small>Mot de passe oublié
              ?</small></a>
        </div>
        <div class="col-6" *ngIf="step=='Mot de passe oublié'"><a href="javascript:void(0)"
            (click)="step='Se connecter';submitted=false;" class="text-dark"><small>Connexion</small></a>
        </div>
        <div class="col-6 text-right pointer"><a href="javascript:void(0)" class="text-dark"
            (click)="navigateTo('register')"><small>Créer un nouveau compte</small></a>
        </div>
      </div>
    </div>
  </div>